export default function beautifyColumnKey(text) {
  if (text == null || text === '') return '';
  return String(text)
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}
